import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { SislogLocation } from '../../../models/SislogLocation';
import { SislogUser } from '../../../models/SislogUser';

export class GetSislogAuthUserService extends HttpServiceBase {

  handle = (input: GetSislogAuthUserServiceInput): Promise<Result<GetSislogAuthUserServiceOutput> | null> => {
    const promise = this.http.post<Result<GetSislogAuthUserServiceOutput>, GetSislogAuthUserServiceInput>(
        `${this.baseUrlSislogApi}/user/zclubinpdv-auth`,
        input);
    return promise;
  }
}

export class GetSislogAuthUserServiceInput {
  email: string;
  password: string;
}

export class GetSislogAuthUserServiceOutput {
  user?: SislogUser | null;
  locations?: SislogLocation[] | null;
  result?: boolean | null;
}